'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getStages = require('./getStages');

var _getStages2 = _interopRequireDefault(_getStages);

var _getEvents = require('./../events/getEvents');

var _getEvents2 = _interopRequireDefault(_getEvents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (feis_id) {
  return function (dispatch) {
    dispatch((0, _getStages2.default)(feis_id));
    dispatch((0, _getEvents2.default)(feis_id));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/getSchedule.js
// module id = 681
// module chunks = 0